var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneHelper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "helfer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1400 1400",
    style: {
      enableBackground: "new 0 0 1400 1400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    d: "M1183.4,995c-69-39-181.5-30-253.5,0c-72,30-489.2,212.2-489.2,212.2v38.7l106.1,52 l-11.5,30.3l200.1-63l0.2-0.1l-9.3,24.4l200.1-63l53.2-17.2l-0.5-0.3c43.2-15.1,155.4-54.8,211.7-77.5 C1261.4,1103,1252.4,1034,1183.4,995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M580.2,1278.5c0,0-4.2,11.8,10.1,14.6c14.3,2.8,78.9,16.4,139.8,0c60.2-16.2,28-47.1,28-47.1 L580.2,1278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC6D23"
    },
    d: "M579.8,1280c0,0,14.5,8.6,47,9.2c32.5,0.6,93.2,2.4,116.5-11.2c23.3-13.6,25.4-23.7,12.7-34.3 S701,1224.7,653,1230s-76.1,25.3-76.1,25.3L579.8,1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M577.7,1262.2c0,0,5.8,14.5,17.5,13.5c11.7-1,24.7-11.3,32.8-20.8s32.9-24.7,39.7-26.5L611,1221 l-34.2,34.2L577.7,1262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373421"
    },
    d: "M385.5,1261.7c0,0-0.6,20.7,3.8,25.4c4.4,4.7,15.2,12.6,27.2,15.5s29.1,12.7,38.5,19.9 c9.5,7.2,24,11.7,53.4,9.8c29.4-1.9,34.9-5.6,38-8.1c3.2-2.5,4.4-16,2.8-25c-1.6-8.9-75.6-19-75.6-19L385.5,1261.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE6E1E"
    },
    d: "M384.9,1253c0,0-0.4,3.5,0.6,8.6c1.9,10.1,9.1,26.5,34.8,33.6c38.5,10.7,25.3,27.8,79.6,27.2 c54.3-0.6,57.1-11.9,42.5-42.9c-14.2-30.3-121.4-42.9-121.4-42.9L384.9,1253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M384.9,1255.6c0,0,4.2,20.6,20.8,26.5c16.6,5.9,34.3,2,45.4-7.9c11.1-9.9,37.6-18,58.1-17.6 l-124.1-8.4L384.9,1255.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314E64"
    },
    d: "M554.7,971.3c0,0,28.3,38.2,34.4,47.1c9.4,13.8,2.9,42.4-2.1,76.3s-15.3,108.2-10.4,159 c0,0,0.7,18.7,22,12c25.9-8.2,28.8-26.1,69.1-37.4c0,0,9.2-143.4,15.5-188.6c6.4-45.2,1.4-164.6-33.2-224.6s-99.6-32.5-99.6-32.5 L554.7,971.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.08
    },
    d: "M584.7,818.9L578.3,931v72.4l1.5,2.1c0,0,30.3-67.2,29.3-150.7c0,0-1-23.3,14.2-26.2 c8.5-1.6,11.5-9.8,11.5-9.8L618,807.2L584.7,818.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E6E89"
    },
    d: "M445.6,799.8c0,0,6.5,169.8,10.2,196.3c5.5,38.3-70.3,159.4-70.9,256.9c0,0,11.2,27.8,38.4,24.2 s37.1-26.3,85.8-20.6c0,0-9.2-45.8,1.4-77.6c10.6-31.8,54.4-127.1,67.8-173s19.8-177.3,12.7-206.2 C584,770.9,445.6,799.8,445.6,799.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12
    },
    d: "M445.8,807.2l0.7,17c0,0,41.9,23.3,85.1,16c43.2-7.3,62-15.8,62-15.8l-0.4-7.9L445.8,807.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#568FB0"
    },
    d: "M383.1,620.3c0,0,28.2,132.1,41.7,169.5c13.4,37.4,78.4,41,113.7,38.1 c35.3-2.8,119.4-30.4,119.4-30.4l-25.4-396.9l-23.4-3.1c0,0-37.4-82.9-84.9-82.1c-73.6,1.3-134.7,20.2-141,49.8 c-6.4,29.7-36,18.4-38.8,46.6C341.4,440.2,383.1,620.3,383.1,620.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.16
    },
    d: "M413.3,422c0,0,26.5,47.1,32.5,84.7s10,92.2,17,110.3s30.5,31.1,30.5,31.1l-25.2,11.4l-80-98.4 L413.3,422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0C3AF"
    },
    d: "M686.2,376.7L467.1,504.1l237.4,132.6l216.6-127.6L686.2,376.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A07E64"
    },
    points: "704.5,636.7 704.5,874.9 921.1,750.6 921.1,509.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFA17F"
    },
    points: "704.5,636.7 467.1,504 467.1,739.7 704.5,874.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M553.2,595.8c-3,0-5.8,2.4-5.8,5.8v14.5c0,4.9,2.6,9.5,6.9,11.9l42.8,24.6 c0.9,0.5,1.9,0.8,2.9,0.8c2.8,0,5.5-2.2,5.7-5.2l-42.7-24.5c-4.3-2.4-6.9-7-6.9-11.9v-14.5c0-0.2,0-0.4,0-0.5l-0.1-0.1 C555.2,596.1,554.2,595.8,553.2,595.8L553.2,595.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M556.2,611.7v-14.5c0-0.2,0-0.4,0-0.5l42.8,25.2c4.2,2.5,6.8,7,6.8,11.8v13.8c0,0.2,0,0.4,0,0.5 l-42.7-24.5C558.8,621.2,556.2,616.6,556.2,611.7z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "704.5,636.7 467.1,504 467.1,510.3 704.5,642.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "704.5,636.7 704.5,642.6 800.9,585.8 800.9,579.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "921.1,509.1 835.1,559.8 835.1,565.6 921.1,514.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "773.6,525.1 738.9,545.2 739,545.3 773.7,525.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "614.9,435.4 599.9,426.8 565,447.1 580,455.6 580,455.6 580,455.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "614.9,435.4 580,455.6 591.7,462.2 626.6,441.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "614.9,435.4 580,455.6 580,455.6 614.9,435.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "646.6,453.3 626.6,441.9 591.7,462.2 611.8,473.5 611.8,473.5 611.8,473.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "646.6,453.3 611.8,473.5 623.5,480.1 658.3,459.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "646.6,453.3 611.8,473.5 611.8,473.5 646.6,453.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "678.3,471.2 658.3,459.9 623.5,480.1 643.5,491.4 643.6,491.4 643.5,491.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "678.3,471.2 643.6,491.4 655.2,498 690,477.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "678.3,471.2 643.5,491.4 643.6,491.4 678.3,471.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "655.2,498 675.3,509.3 710.1,489.2 690,477.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "687.1,516 721.8,495.8 710.1,489.2 675.4,509.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "741.8,507.1 721.8,495.8 687.1,516 707.1,527.3 707.2,527.3 707.1,527.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "707.2,527.3 718.8,533.9 753.5,513.7 741.9,507.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "741.8,507.1 707.1,527.3 707.2,527.3 741.9,507.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "753.5,513.7 718.8,533.9 734.2,542.6 738.9,545.2 773.6,525.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "785.3,531.7 773.7,525.1 739,545.3 750.7,551.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "835.1,577.4 835.1,563.7 800.9,583.9 800.9,597.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "835.1,613.9 835.1,600.2 800.9,620.4 800.9,633.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "785.3,531.7 750.7,551.8 770.9,563.1 805.4,543.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "805.4,543.1 770.9,563.1 782.6,569.7 817,549.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "770.9,563.1 770.7,563.2 770.8,563.2 770.9,563.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "805.4,543.1 770.9,563.1 770.9,563.1 805.4,543.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "826.4,555 826.4,555 817,549.7 782.6,569.7 792.2,575.1 792.2,575.1 797.3,578  831.4,557.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "817,549.7 782.6,569.7 800.9,579.9 835.1,559.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "800.9,583.9 835.1,563.7 835.1,559.8 800.9,579.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "800.9,620.3 835.1,600.2 835.1,577.1 800.9,597.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8B4026"
    },
    points: "800.9,657 835.1,636.8 835.1,613.7 800.9,633.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "826.3,655.3 826.3,655.3 826.3,655.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "828.7,653.9 828.7,653.9 828.7,653.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "809.5,665.1 809.5,665 809.5,665.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "811.9,663.7 811.9,663.6 811.9,663.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "819.1,659.5 819.1,659.4 819.1,659.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "816.7,660.9 816.7,660.8 816.7,660.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "807.1,666.5 807.2,666.4 807.1,666.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "823.9,656.7 823.9,656.7 823.9,656.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "814.3,662.3 814.3,662.2 814.3,662.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "821.5,658.1 821.5,658.1 821.5,658.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "802.4,669.2 802.4,669.2 802.3,669.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "804.8,667.9 804.8,667.8 804.7,667.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "833.6,651.1 833.6,651.1 833.5,651.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "831.1,652.5 831.2,652.5 831.1,652.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#571E0B"
    },
    points: "802.4,669.2 802.7,666.6 804.7,667.8 804.8,667.8 805,665.2 807.1,666.5 807.2,666.4  807.4,663.8 809.5,665.1 809.5,665 809.8,662.5 811.9,663.7 811.9,663.6 812.2,661.1 814.3,662.3 814.3,662.2 814.6,659.7  816.7,660.9 816.7,660.8 817,658.3 819.1,659.5 819.1,659.4 819.4,656.9 821.5,658.1 821.5,658.1 821.8,655.5 823.9,656.7  823.9,656.7 824.2,654.1 826.3,655.3 826.3,655.3 826.6,652.7 828.7,653.9 828.7,653.9 829,651.3 831.1,652.5 831.2,652.5  831.4,649.9 833.5,651.1 833.6,651.1 833.9,648.5 835.1,649.2 835.1,636.6 800.9,656.7 800.9,668.4 802.3,669.2  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 830.1,
    y1: 653.1,
    x2: 829.8,
    y2: 652.9
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#121B1E"
    },
    points: "680.1,574.3 800.9,579.9 921.1,509.1 783.5,431.6 733.6,464.6 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5C7B3"
    },
    d: "M536.1,367.4l144,84.9L838,364l-145.7-84.7L536.1,367.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8BAA0"
    },
    points: "680.1,452.2 680.1,574.3 536.1,491.7 536.1,367.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B8067"
    },
    points: "680.1,452.2 838,364 838,484.4 680.1,574.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6CDBB"
    },
    d: "M780.7,425.1c-0.6,0-1.3,0.2-1.9,0.5l-0.1,0c0,0.1,0,0.2,0,0.4v9.6c0,3.3-1.7,6.3-4.6,7.9 l-28.4,16.3c0.2,2,1.9,3.5,3.8,3.5c0.6,0,1.3-0.2,1.9-0.5l28.5-16.3c2.8-1.6,4.6-4.6,4.6-7.9v-9.6 C784.6,426.7,782.7,425.1,780.7,425.1L780.7,425.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040E14"
    },
    d: "M778.8,435.6V426c0-0.1,0-0.2,0-0.4l-28.5,16.8c-2.8,1.6-4.5,4.6-4.5,7.9v9.2c0,0.1,0,0.2,0,0.4 l28.4-16.3C777,441.9,778.8,438.9,778.8,435.6z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8E6E56"
    },
    points: "680.1,452.2 838,364 838,368.2 680.1,456.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "680.1,452.2 680.1,456.2 616.1,418.4 616.1,414.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#694C3A"
    },
    points: "536.1,367.4 593.3,401.1 593.3,405 536.1,371.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "634.2,378 657.3,391.4 657.2,391.5 634.2,378.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "739.7,318.4 749.7,312.7 772.9,326.2 762.9,331.9 762.9,331.8 762.9,331.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "739.7,318.4 762.9,331.8 755.2,336.2 732,322.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "739.7,318.4 762.9,331.8 762.9,331.8 739.7,318.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "718.7,330.3 732,322.7 755.2,336.2 741.8,343.8 741.8,343.8 741.8,343.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "718.6,330.3 741.8,343.8 734,348.1 710.9,334.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "718.7,330.3 741.8,343.7 741.8,343.8 718.6,330.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "697.6,342.2 710.9,334.7 734,348.1 720.7,355.7 720.7,355.7 720.7,355.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "697.5,342.2 720.7,355.7 712.9,360 689.8,346.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "697.6,342.2 720.7,355.6 720.7,355.7 697.5,342.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "712.9,360 699.6,367.6 676.5,354.1 689.8,346.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "691.7,372 668.6,358.6 676.4,354.2 699.5,367.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "655.3,366.1 668.6,358.6 691.7,372 678.4,379.5 678.4,379.5 678.4,379.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "678.4,379.5 670.6,383.9 647.6,370.5 655.3,366.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "655.3,366.1 678.4,379.5 678.4,379.5 655.3,366.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "647.6,370.5 670.6,383.9 660.4,389.7 657.3,391.4 634.2,378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "626.4,382.4 634.2,378.1 657.2,391.5 649.4,395.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "593.3,412.8 593.3,403.7 616.1,417.1 616.1,426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "593.3,437.1 593.3,428 616.1,441.4 616.1,450.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "626.4,382.4 649.4,395.8 636,403.3 613.1,390  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5E6743"
    },
    points: "613.1,390 636,403.3 628.2,407.7 605.3,394.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "636,403.3 636.1,403.4 636.1,403.4 636,403.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7C2B0B"
    },
    points: "613.1,390 636,403.3 636,403.3 613.1,390  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B05932"
    },
    points: "599.1,397.9 599.1,397.9 605.3,394.4 628.2,407.7 621.8,411.3 621.8,411.3 618.5,413.2  595.7,399.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9FAA72"
    },
    points: "605.3,394.4 628.2,407.7 616.1,414.5 593.3,401.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "616.1,417.1 593.3,403.7 593.3,401.1 616.1,414.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "616.1,441.4 593.3,428 593.3,412.6 616.1,426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F8257"
    },
    points: "616.1,465.7 593.3,452.3 593.3,437 616.1,450.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "599.1,464.6 599.1,464.6 599.2,464.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "597.5,463.7 597.5,463.7 597.6,463.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "610.3,471.1 610.3,471.1 610.3,471.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "608.7,470.2 608.7,470.2 608.7,470.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "603.9,467.4 603.9,467.4 604,467.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "605.5,468.3 605.5,468.3 605.6,468.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "611.9,472.1 611.9,472 611.9,472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "600.7,465.6 600.7,465.5 600.8,465.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "607.1,469.3 607.1,469.2 607.1,469.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "602.3,466.5 602.3,466.5 602.4,466.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "615.1,473.9 615.1,473.9 615.1,473.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "613.5,473 613.5,472.9 613.5,473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "594.3,461.9 594.3,461.8 594.4,461.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "595.9,462.8 595.9,462.7 596,462.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495030"
    },
    points: "615.1,473.9 614.9,472.1 613.5,473 613.5,472.9 613.3,471.2 611.9,472 611.9,472  611.7,470.3 610.3,471.1 610.3,471.1 610.1,469.4 608.7,470.2 608.7,470.2 608.5,468.5 607.1,469.3 607.1,469.2 606.9,467.5  605.6,468.3 605.5,468.3 605.3,466.6 604,467.4 603.9,467.4 603.7,465.7 602.4,466.5 602.3,466.5 602.1,464.7 600.8,465.5  600.7,465.5 600.5,463.8 599.2,464.6 599.1,464.6 598.9,462.9 597.6,463.7 597.5,463.7 597.3,462 596,462.8 595.9,462.7  595.7,461 594.4,461.8 594.3,461.8 594.1,460.1 593.3,460.6 593.3,452.2 616.1,465.6 616.1,473.3 615.1,473.9  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#571E0B"
    },
    x1: 596.6,
    y1: 463.1,
    x2: 596.9,
    y2: 463
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.16
    },
    d: "M562.8,794.3c0,0,62.8-1.4,81.1-14.3s12.8-38.5,12.8-38.5l-125.1,35L562.8,794.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.16
    },
    d: "M467.1,645.6c0,0,56.1,44.1,69.8,57.1c12.8,12.1,21.8,10.9,26.5,8s7.7-10.3,24.7-13.8 c17-3.5,16.3,9.3,11.9,13.8c-4.4,4.5-52.5,21.5-52.5,21.5l-51.6-32.6l-28.8-43.6V645.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28495B"
    },
    d: "M523.3,787c0,0,2,1.8,4.8,1c4.6-1.2,10.9-9.1,12.8-18.2c1.9-9.2,14.7-52.5-1.6-62 c-6.9-4-16.8,7.1-16.8,7.1l-13.3,34.3l4.8,21L523.3,787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.16
    },
    d: "M397.4,684.3c0,0,2.4,10.2,4.1,17.5c0,0,39.9,44,79.8,70c38.5,25.1,46.6,22.3,52.2,20 s15.3-9.9,15.3-9.9L486,719.8L397.4,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8F1D6"
    },
    d: "M514,776.5c0,0,43.1,11.5,71.6,9.2c28.5-2.3,49.8-3.6,60.2-10c10.4-6.4,10.9-14.1,11.7-26.1 c0.8-12-7.3-17.5-24.3-16.6c-17.1,0.9-41.2,1.4-45.3-0.3s1.1-16.2,10.6-20.5c9.5-4.3,4.1-18.8-8.2-14.7c-12.3,4.1-20.6,10.6-24.5,16 c-3.9,5.4-22.2,4.1-35.2-2.5C517.6,704.6,514,776.5,514,776.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73A6C9"
    },
    d: "M535.3,704.5c0,0-49.4-40.7-74.3-59c-22.2-16.3-17.1-123.4-36.2-195.4c-19.1-72-81.6-71-94.3-32.8 s-4.2,123.9,21.2,192.8s58.3,102.8,91.1,126.1s80.5,50.9,80.5,50.9S497,737.3,535.3,704.5z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M526.5,741.5c4-19,11.9-27.2,11.9-27.2l0,0c-2.7-0.9-5.3-1.9-7.8-3.1c-13-6.6-16.6,65.4-16.6,65.4s5.7,1.5,14.3,3.4 C528.3,779.9,522.5,760.4,526.5,741.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93BED6"
    },
    d: "M504.2,775.6c0,0-21.7-33.7,14.3-76.3c0,0,3.8-5.4,7.1-2.7c3.3,2.7,10.7,8.9,13.7,11.2 c0,0-1.7-0.9-6.4,3.1c-4.7,4-20,22.5-14.7,59.3c0,0,0.9,12.9,7.4,17.8C525.6,788.1,511.8,781.6,504.2,775.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9681 -0.2504 0.2504 0.9681 -176.5889 152.0527)",
    style: {
      fill: "#495030"
    },
    cx: 509.3,
    cy: 770,
    rx: 3.2,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9681 -0.2504 0.2504 0.9681 -176.6321 151.9444)",
    style: {
      fill: "#7F8257"
    },
    cx: 508.8,
    cy: 770.1,
    rx: 3,
    ry: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9681 -0.2504 0.2504 0.9681 -173.8765 151.2464)",
    style: {
      fill: "#495030"
    },
    cx: 507.4,
    cy: 758.9,
    rx: 3.2,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9681 -0.2504 0.2504 0.9681 -173.9197 151.1381)",
    style: {
      fill: "#7F8257"
    },
    cx: 507,
    cy: 759.1,
    rx: 3,
    ry: 4.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#33687F"
    },
    d: "M405.6,339.8c0,0-1.6,14.9,24.4,29.4c32.6,18.2,56.3,17.3,71,13.5 c14.7-3.8,15.7-34.6,12.9-50.8c-2.8-16.2-99.1,3.2-99.1,3.2L405.6,339.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3C4A3"
    },
    d: "M405.6,279c0,0,5.5,19.4,11.5,41.2c3,11-9.1,21.5-2.4,26.4c6.8,4.9,35.5,21,62.7,20.3 c27.2-0.7,30.6-4.6,36.4-35c5.7-30.4-4.5-52.7-4.5-52.7L405.6,279z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.8,283.1l-16.6-3.9l-88.7-0.2c0,0,1.3,4.6,3.3,11.7c13.5,13.1,45.4,40.4,78.3,43.5c11.5,1.1,20.5-1.6,27.3-6.2 C517.6,306.9,513.3,290.3,510.8,283.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0CFA8"
    },
    d: "M393.7,262.1c0,0,12.7,22.5,19.7,27.6c7,5.1,56.9,25,75.5,27.1c18.6,2,37.4-14.1,40.1-23.7 s9.9-47.2,6.8-74.5c-3.1-27.3-9.6-74.1-23-93.5c-13.3-19.4-92,20.2-92,20.2l-41,46.1l-1,38.9L393.7,262.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#563D2B"
    },
    d: "M401.9,275.2c0,0-1-15.2-8.3-31.5s-5.6-24.1,3.3-27.4c8.9-3.3,23.8,6.5,26.2,14.8s8.3,9.9,8.5,4.8 c0.2-5.1-3.5-30.4-9.8-44.5c-6.3-14.1,69.6-25.2,97.5-76.3c0,0,10.1-12.1-3.8-17.3S486,82.2,470.7,76c-15.2-6.2-37.8-9.5-68.2,1.4 S365,105.1,365,105.1s-21.6,9.5-27.9,32S334.9,217.7,401.9,275.2z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.3,273.8l1.6,1.4C401.3,274.7,400.8,274.3,400.3,273.8C400.3,273.8,400.3,273.8,400.3,273.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.2,219c-1.8,8.2,1.5,17.7,7.3,26.2c5.8,8.5,8.8,28.4,8.8,28.7c0.5,0.5,1,0.9,1.6,1.4c0,0-1-15.2-8.3-31.5 c-7.3-16.2-5.6-24.1,3.3-27.4c7.6-2.8,19.6,3.9,24.4,11.1l0,0C408.7,200.9,386,210.8,384.2,219z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M421.7,191.4c0.6,1.3,1.2,2.8,1.7,4.3v0c0,0,0-8.2,7-8.9c7-0.7,65.4-17,89-48.3c0,0,0.1-0.1,0.1-0.1 c-2-5.2-4.3-9.7-6.7-13.3C481.2,167.8,415.8,178.3,421.7,191.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneHelper);
export default __webpack_public_path__ + "static/media/one-helper.dff5e3dd3cb7e57a2c44492ffb9bfe65.svg";
export { ForwardRef as ReactComponent };